import { styled } from '@mui/system';
import { Typography, TableContainer } from '@mui/material';

export const CustomListContainer = styled(TableContainer)(({ theme }) => ({
  background: theme.palette.primary.main,
  borderRadius: '12px',
  display: 'flex',
  padding: 0,
  margin: 0,
  flexDirection: 'column',
  cursor: 'pointer',
  width: '100%',
  listStyle: 'none',
  minWidth: 'fit-content',
  overflow: 'auto',
}));

export const CustomListEntryContainer = styled('li')(({ theme }) => ({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  display: 'block',
  cursor: 'pointer',
  transition: 'background-color 0.2s ease',
  '&:hover': {
    backgroundColor: theme.palette.background.secondaryHover,
  },
}));

export const CustomListEntryContent = styled('div')(({ condensed = false, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  width: '100%',
  height: condensed ? '3.25rem' : '3.75rem',
  paddingLeft: theme.spacing(2),
}));

export const MainContentContainer = styled('div')(({ isLast, theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  borderBottom: isLast ? 'none' : `1px solid ${theme.palette.divider}`,
  paddingRight: theme.spacing(2),
}));

export const PrimaryText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  marginBottom: 0,
  whiteSpace: 'nowrap',
}));

export const SecondaryText = styled(Typography)(({ theme, status = 'default' }) => ({
  color: (() => {
    switch (status) {
      case 'current':
        return theme.colors.white; // white for current date
      case 'completed':
        return theme.colors.green; // green for completed/logged items
      case 'actionRequired':
        return theme.colors.blue; // blue for upcoming actions
      case 'financial':
        return theme.colors.yellow; // yellow for financial info
      case 'error':
        return theme.palette.error.main; // red for error
      default:
        return theme.colors.gray; // gray for everything else
    }
  })(),
  marginBottom: 0,
  whiteSpace: 'nowrap',
}));
